import { useCreateOrganizationContext } from '../context';
import * as S from './styles';

export function Content() {
	const { steps, currentStep } = useCreateOrganizationContext();

	return <S.Container span={24}>{steps[currentStep]?.component}</S.Container>;
}
